import { render, staticRenderFns } from "./CloseX.vue?vue&type=template&id=f004e66a&"
import script from "./CloseX.vue?vue&type=script&lang=js&"
export * from "./CloseX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports